import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/eventManagement",
    },
    {
      path: "/event",
      component: (resolve) => require(["@/common/Home.vue"], resolve),
      meta: { title: "自述文件" },
      children: [
        {
          path: "/eventManagement",
          component: (resolve) =>
            require(["@/view/eventManagement/index.vue"], resolve),
          meta: { title: "活动管理" },
        },
        {
          path: '/reviewCenter',
          component: (resolve) => 
            require(["@/view/reviewCenter/index.vue"], resolve),
          meta: { title: '审核中心' }
        },
        {
          path: '/rightsCenter',
          component: (resolve) => 
            require(["@/view/rightsCenter/index.vue"], resolve),
          meta: { title: '权益中心' }
        }
      ],
    },
    {
      path: "/login",
      component: (resolve) => require(["@/common/Login.vue"], resolve),
    },
    {
      path: "/user-agreement",
      component: (resolve) => require(["@/common/UserAgreement.vue"], resolve),
      meta: { title: "用户服务协议" },
    },
    {
      path: "/privacy-policy",
      component: (resolve) => require(["@/common/PrivacyPolicy.vue"], resolve),
      meta: { title: "隐私政策" },
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js